import { CommissionsBatchBase } from "./types";

export const removeBatchNameCustomSuffix = (batch: CommissionsBatchBase): string => batch.name.substring(0, 10);
